import React, { useState } from "react";
import { useForm } from "react-hook-form";
import api from "../../api/axiosInstance";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

const LoginForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const { login } = useAuth();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const onSubmit = async (data) => {
    try {
      const response = await api.post("/api/login", {
        username: data.email,
        password: data.password,
      });

      const { access_token } = response.data;
      login(access_token);
      setSuccess("Login successful!");
      setTimeout(() => navigate("/domains"), 2000);
    } catch (err) {
      setError("Invalid credentials. Please try again.");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="row">
      <div className="form-group col-md-5">
        <div>
          <label>Email</label>
          <input
            className="form-control"
            type="email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                message: "Invalid email address",
              },
            })}
          />
          {errors.email && (
            <p className="alert alert-danger">{errors.email.message}</p>
          )}
        </div>

        <div>
          <label>Password</label>
          <input
            className="form-control"
            type="password"
            {...register("password", {
              required: "Password is required",
              minLength: {
                value: 6,
                message: "Password must be at least 6 characters",
              },
            })}
          />
          {errors.password && (
            <p className="alert alert-danger">{errors.password.message}</p>
          )}
        </div>

        {error && <p className="alert alert-danger">{error}</p>}
        {success && <p className="alert alert-success">{success}</p>}

        <button className="btn btn-primary" type="submit">
          Login
        </button>
      </div>
    </form>
  );
};

export default LoginForm;
